// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (function () {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  console.log.apply(console, args);
});
